var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"dark":"","src":require("@/assets/img/hero-banner.png"),"id":"v-parallax_fallback-bg"}},[_c('DemoSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }